import Vue from 'vue'
import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

Vue.component('fa', FontAwesomeIcon)

import {
  faUser, faLock, faSignOutAlt, faCog, faBars, faPencilAlt, faTimes, faPlus, faCalendarAlt, faEnvelope
} from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(
  faUser, faLock, faSignOutAlt, faCog, faBars, faPencilAlt, faTimes, faPlus, faCalendarAlt, faEnvelope
)
